var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"mask"},[_c('van-loading',{attrs:{"type":"spinner","color":"#ff7b00"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }